export default __webpack_public_path__ + "static/media/Weather6.6e151530.PNG";